import React from "react";
import {
  CardContainer,
  IconWrapper,
  CardTitle,
  CardValue,
  CardSubtitle,
} from "../styles";

interface Props {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  color: string;
  rawIcon?: boolean;
  bgColor?: string;
  subtitle?: React.ReactNode;
}

const StatCard: React.FC<Props> = ({
  title,
  value,
  icon,
  color,
  rawIcon,
  bgColor,
  subtitle,
}) => (
  <CardContainer>
    {rawIcon ? (
      <div
        style={{
          marginRight: "0.4rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: bgColor || "transparent",
          borderRadius: "9999px",
          padding: bgColor ? "0.5rem" : 0,
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
    ) : (
      <IconWrapper color={color}>{icon}</IconWrapper>
    )}
    <div>
      <CardTitle>{title}</CardTitle>
      <CardValue valueColor={color}>{value}</CardValue>
      {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
    </div>
  </CardContainer>
);

export default StatCard;
